import React, { type FunctionComponent } from 'react';

import { Button, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

import UnassignedUserList from './UnassignedUserList';
import { type BreakoutUser } from '../../../types/breakoutRoomTypes';
import { StyledButtonContainer, StyledButtonGroup } from '../styles/styled-components';

interface BreakoutRoomRowProps {
    unassignedUsers: BreakoutUser[];
    roomName: string;
    roomId: string;
}

const AssignUsers: FunctionComponent<BreakoutRoomRowProps> = ({ roomId, unassignedUsers }) => {
    const { t } = useTranslation('breakout_room');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const open = Boolean(anchorEl);

    const disable = unassignedUsers.length === 0;

    return (
        <StyledButtonContainer>
            <StyledButtonGroup>
                <Button
                    aria-describedby={t('assign-popup')}
                    variant="contained"
                    onClick={handleClick}
                    disabled={disable}
                    size="small"
                >
                    {t('assign')}
                </Button>
                <Popover
                    id={t('assign')}
                    open={open && !disable}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                >
                    <UnassignedUserList
                        onCloseHandler={() => setAnchorEl(null)}
                        roomId={roomId}
                        userList={unassignedUsers}
                    />
                </Popover>
            </StyledButtonGroup>
        </StyledButtonContainer>
    );
};

export default AssignUsers;
